import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/functions";
import {isNil}  from "lodash";

import store from "@/store";

firebase.auth().onAuthStateChanged(
    async firebaseUser => {
        const actionToDispatch = isNil(firebaseUser) ? "logout" : "login";
        await store.dispatch(`authentication/${actionToDispatch}`, firebaseUser);

        if (
            store.state.authentication.user !== null &&
            store.state.authentication.user.role === 'administrator'
        ) {
            await store.dispatch("demands/hideOldDemands");
        }
    }
);
